import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class BankAccountCreation {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend,
  ) { }

  async run(id:string, company_id:Number, institution:string, country:string, iban:string, ownerName:string, cuenta_bancos:string, cuenta_partidas_abiertas:string, currency:string, use_sandbox:boolean, provider_name:string): Promise<any> {
    if (this.frontend.check_accounts()) {
      if(this.frontend.currentTab == '1') { //provider
        let args = { 
          id: id,
          company_id: company_id,
          institution: institution,
          country: country,
          cuenta_bancos: cuenta_bancos,
          cuenta_partidas_abiertas: cuenta_partidas_abiertas,
          provider_name: provider_name,
        }
        if (use_sandbox == true) {
          args['use_sandbox'] = true;
          args.institution = 'Sandbox';
          args.country = 'ES';
          if (provider_name=='enablebanking') {
            args.provider_name = 'enablebanking_sandbox'
            args.institution = 'Mock ASPSP'
          }
        }
        let res = await this.dispatcher.dispatch('bank_account_register.data', args)
        if (res.output['status'] === '200') {
          if (provider_name == 'afterbanks') {
            let tmp = this.frontend.original_institution_list.filter(item => item.name == this.frontend.institution)
            this.frontend.$router.push({name: 'bank-creation', params: { company_id: company_id, bank_account_id: id, service_id: tmp[0].id}});
          } else {
            this.frontend.redirect_url = res.output['info']
            this.frontend.redirect_to_url()
          }
        } else {
          return res.output['info']
        }
      } else if (this.frontend.currentTab == '0') { //manual
        let args = { 
          id: id,
          company_id: company_id,
          institution: institution,
          country: country,
          iban: iban,
          ownerName: ownerName,
          cuenta_bancos: cuenta_bancos,
          cuenta_partidas_abiertas: cuenta_partidas_abiertas,
          provider_name: 'manual',
          currency: currency
        }
        let res = await this.dispatcher.dispatch('bank_account_register.data', args)
        if (res.output['status'] === '200') {
          this.frontend.$router.push({ name: 'bank-accounts' })
        }
      }
      this.frontend.cuenta_bancos_error = false;
      this.frontend.cuenta_partidas_abiertas_error = false;
    }
    this.frontend.loading_registration = false;
  }
}